import { render, staticRenderFns } from "./product-category-1.vue?vue&type=template&id=0a9d21ae&"
import script from "./product-category-1.vue?vue&type=script&lang=js&"
export * from "./product-category-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports